/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:3d8348d5-46cf-4f6a-bd2a-bbb534fe164d",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_3B7s21HE2",
    "aws_user_pools_web_client_id": "54vtg5j1a6dm8bods0lpqgeun4",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "carsda1411ac6b0b4de8b8003fe5d8ad70f1d479c-master",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
